export default __webpack_public_path__ + "fonts/d87ecf59e6ecc3bc0d5e2c58508f52a7.woff2";